import { FC } from "react";

import { Flex, SystemProps } from "@chakra-ui/react";

import PageSwitcher from "./components/PageSwitcher";
import TotalCount from "./components/TotalCount";
import type { TPaginationProps } from "./types";

const LOW_TOTAL_COUNT_THRESHOLD = 30;

const getPaginationJustify = (isCentered: boolean, hasTotalCount: boolean): SystemProps["justifyContent"] => {
  if (isCentered) {
    return "center";
  }
  if (hasTotalCount) {
    return "space-between";
  }
  return "flex-end";
};

const Pagination: FC<TPaginationProps> = ({
  hasTotalCount,
  hasPageSwitcher,
  currentPage = 0,
  totalCount = 0,
  pageSize = 0,
  onPreviousPageClick,
  onNextPageClick,
  nextPageHref,
  previousPageHref,
  isCentered,
  isShowingLowTotalCount,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  const hasLowTotalCount = totalCount < LOW_TOTAL_COUNT_THRESHOLD;
  const hasItems = totalCount > 0;
  const hasMoreThanOnePage = totalPages > 1;

  const isShowingTotalCount =
    hasTotalCount && hasMoreThanOnePage && hasItems && (!hasLowTotalCount || isShowingLowTotalCount);

  return (
    <Flex justify={getPaginationJustify(!!isCentered, !!isShowingTotalCount)} fontWeight="300">
      {isShowingTotalCount && <TotalCount count={totalCount} />}
      {hasPageSwitcher && (
        <PageSwitcher
          currentPage={currentPage}
          totalPages={totalPages}
          onPreviousPageClick={onPreviousPageClick}
          onNextPageClick={onNextPageClick}
          previousPageHref={previousPageHref}
          nextPageHref={nextPageHref}
        />
      )}
    </Flex>
  );
};
export default Pagination;
